const getTimerTypeDescription = (type: string): string => {
  switch (type) {
  case 'one_shot':
    return `${I18n.t('timers.one_shot_description')}`
  case 'repeating':
    return `${I18n.t('timers.repeating_description')}`
  case 'retriggerable':
    return `${I18n.t('timers.retriggerable_description')}`
  default:
    return ''
  }
}

export default getTimerTypeDescription
